require('./modifyMainPhoneStep2.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// @components
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY, CONFIRMATION_SCRIPT_AGREEMENT  } = require('components/contactCenter/confirmScript/confirmationScript');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
// @constants
const { FIRST_STEP } = require('constants/index');
const { mobilePhoneCodes } = require('constants/contactCenter/modifyMainPhone');
// @helpers
const { getPhoneById } = require('utilities/contactCenter/modifyMainPhoneHelper');

class ModifyMainPhoneStep2 extends React.Component {
    render() {
        const { immModifyMainPhone } = this.props;
        const operativeName = 'operatives-modifyMainPhoneNumber';
        const phonesList = immModifyMainPhone.getIn(['mainContactPhoneData', 'listaDispositivos']).toJS();
        const currentPhoneId = immModifyMainPhone.getIn(['steps', FIRST_STEP, 'currentPhoneId'])
        const selectedPhoneId = immModifyMainPhone.getIn(['steps', FIRST_STEP, 'selectedPhoneId'])
        const currentPhone = getPhoneById(phonesList, currentPhoneId);
        const currentPhoneLabel = mobilePhoneCodes.includes(currentPhone.tipoUso) ? 'step2CurrentNumberLabel' : 'step2CurrentLandLineLabel'
        const selectedPhone = getPhoneById(phonesList, selectedPhoneId);

        return (
            <article
                className="modify-main-phone-step-2"
                id="printable-wizard"
            >
                <header className="wizard_header">
                    <h1 className="wizard-step--vertical__title">
                        <FormattedText value="modifyMainPhone-step2Title" />
                    </h1>
                </header>
                <div className="modify-main-phone-step-2__content">
                    <ConfirmationScript operative={formatText(operativeName)} confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY} />
                    <OKInformativeList
                        columns={1}
                    >
                        <OKInformativeListItem title={formatText(`modifyMainPhone-${currentPhoneLabel}`)}>
                            {currentPhone.detalleContacto}
                        </OKInformativeListItem>
                    </OKInformativeList>
                    <OKInformativeList
                        columns={1}
                    >
                        <OKInformativeListItem title={formatText('modifyMainPhone-step2NewSelectedNumberLabel')}>
                            {selectedPhone.detalleContacto}
                        </OKInformativeListItem>
                    </OKInformativeList>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </div>
            </article>
        );
    }
}

ModifyMainPhoneStep2.propTypes = {
    immModifyMainPhone: PropTypes.object.isRequired
};

module.exports = ModifyMainPhoneStep2;
